import React from 'react';
import { useTranslation } from 'react-i18next';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

import { MEDIA_TYPES } from '../../../constants';
import Icon from '../../../icons/Icon';

import scss from './Attachments.module.scss';

function Attachments({ attachments }) {
  const { t } = useTranslation('studio');

  return (
    <div className={scss.wrapper}>
      <span className={scss.title}>{t('attachedFiles')}:</span>
      <div className={scss.attachments}>
        {attachments.map((attachment) =>
          attachment.type === MEDIA_TYPES.IMAGE ? (
            <AttachmentImage key={attachment.id} attachment={attachment} />
          ) : (
            <AttachmentFile key={attachment.id} attachment={attachment} />
          ),
        )}
      </div>
    </div>
  );
}

export default Attachments;

function AttachmentImage({ attachment }) {
  const { thumbnailUrl, name } = attachment;
  return <img className={scss.attachedImage} src={thumbnailUrl} alt={name} />;
}

function AttachmentFile({ attachment }) {
  const { name } = attachment;
  return (
    <div className={scss.chip} title={name}>
      <Icon icon={InsertDriveFileOutlinedIcon} className={scss.fallbackIcon} />

      <span className={scss.name}>{name}</span>
    </div>
  );
}
